import BigNumber from 'bignumber.js'
import { _E } from 'constants/constants'
import { PERCENT } from 'constants/number'

type avgAPYProps = {
  amount: BigNumber
  APY: BigNumber
}[]
export const avgAPY = (data: avgAPYProps) => {
  return BigNumber.sum(...data.map((d) => d.amount.times(d.APY.div(PERCENT))))
    .div(BigNumber.sum(...data.map((d) => d.amount.abs())))
    .times(PERCENT)
}

export const apr2apy = (apr: BigNumber) => {
  // e^APR -1
  // return _E.exponentiatedBy(apr).minus(ONE)
  return new BigNumber((Math.pow(_E.toNumber(), apr.toNumber()) - 1) * 100)
}
